<template lang="pug">
    .account-list
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
        el-card.contains-table(shadow="always")
            //- router-view.account-form(:key="$route.path" :class="{'loading-panel': loading}")
            router-view.account-form
</template>

<i18n>
{
    "de": {
        "New Account": "Neuer Account",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Account list could not be fetched.": "Benutzerliste konnte nicht abgerufen werden."
    }
}
</i18n>

<script>
import { mapActions, mapGetters } from 'vuex'

import Tabs from '@/components/Tabs';

export default {
    name: 'SystemAccountListe',
    components: {
        Tabs
    },
    computed: {
        tabs() {
            return [
                {
                    name: this.$t('Accounts'),
                    path: '/system/accounts',
                    icon: {
                        name: 'user-tie',
                        group: 'fas'
                    }
                },
                {
                    name: this.$t('Websites'),
                    path: '/system/abonements',
                    icon: {
                        name: 'cubes',
                        group: 'fas'
                    }
                },
            ]
        },
        ...mapGetters({
            loading: 'settings/loading'
        })
    },
    methods: {
        ...mapActions({
            activateTab: 'activateTab'
        }),
    },
}
</script>

<style lang="sass" scoped >
    .el-button--medium.is-circle
        padding: 5px

    .mimic-button
        &[disabled]
            pointer-events: none
        &:not([disabled]):hover
            background: $--color-primary
            border-color: $--color-primary

    .account-list
        :deep()
            .column.name
                position: relative
                .is-owner
                    font-size: 0.6rem
                    position: absolute
                    color: $--color-primary
                    top: 0
                    left: -10px
                    // i
                    //     padding: 3px
                    //     border-radius: 50%
                    //     background: $ci-color-primary
</style>
